<template>
  <div
    class="deposit-form-select-wrap"
    :class="variant === 'withdraw' ? 'is-withdraw' : 'is-deposit'"
  >
    <v-select
      v-model="data[field]"
      class="deposit-form-select"
      :reduce="(account) => account.id"
      label="name"
      :options="accounts"
      :searchable="accounts.length > 5"
      :clearable="false"
      placeholder="Account"
    >
      <template slot="option" slot-scope="option">
        <div class="account-option">
          <div class="account-option__title">{{ option.name }}</div>
          <div
            v-if="option.account_name || option.number"
            class="account-option__meta"
          >
            <span v-if="option.account_name">{{ option.account_name }}</span>
            <span v-if="option.account_name && option.number"> · </span>
            <span v-if="option.number">{{ option.number }}</span>
          </div>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <span class="account-option__selected">{{ option.name }}</span>
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Object, required: true },
    field: { type: String, required: true },
    accounts: { type: Array, default: () => [] },
    /** Match deposit amount inputs (white) or withdraw fields (#FFE93C) */
    variant: {
      type: String,
      default: 'deposit',
      validator: (v) => ['deposit', 'withdraw'].includes(v),
    },
  },
};
</script>
<style scoped>
.deposit-form-select-wrap >>> .vs__dropdown-menu {
  background: #2b0000;
  border: 1px solid rgba(255, 233, 60, 0.45);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  z-index: 1050;
  max-height: 280px;
}

.deposit-form-select-wrap >>> .vs__dropdown-option {
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.deposit-form-select-wrap >>> .vs__dropdown-option--highlight {
  background: rgba(238, 10, 36, 0.35) !important;
  color: #ffe93c !important;
}

.account-option__title {
  font-weight: 600;
  line-height: 1.3;
}

.account-option__meta {
  font-size: 0.85rem;
  color: #ffe93c;
  margin-top: 2px;
}

.account-option__selected {
  font-size: 0.875rem;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}
</style>
